// GTIP (HS) kodu jeneratörler için üretilir. 8502 = elektrojen (jeneratör) grupları.
//
// Yakıt/tip belirleme (ürün verisine göre):
//  - Benzinli portatif → SAP kodu "7" ile başlar VE adında "GJB" geçer → 8502.20
//    (Not: "6." ile başlayan GJB… modelleri Baudouin motorlu DİZEL'dir, benzinli değil.)
//  - Diğer tüm jeneratörler → dizel, kVA bandına göre:
//      ≤75 → 8502.11, 75–375 → 8502.12, ≥375 → 8502.13  (sınır kVA alt banda dahil)
//
// kVA kaynağı önceliği: açık verilen kVA (fiyat listesi) > addaki "### KVA" > model kodundaki rakam.
// Jeneratör olmayan kalemlere (ATS, pano, yedek parça…) kod atanmaz → null.

export interface GtipInput {
	/** SAP ürün kodu, ör. "6.202300046", "7.000000024" */
	code?: string | null;
	/** Ürün adı/açıklaması, ör. "GJR110-MAR 110KVA ..." */
	name?: string | null;
	/** Fiyat listesi model kodu, ör. "GJR110" */
	model?: string | null;
	/** Bilinen kVA (fiyat listesi standby/prime) */
	kva?: number | null;
}

/** Metindeki "### KVA" kalıbından kVA yakalar (ör. "110KVA", "300XKVA" → 300). */
function kvaFromText(text: string): number | null {
	const m = text.match(/(\d+(?:[.,]\d+)?)\s*X?\s*KVA/i);
	if (!m) return null;
	const v = Number(m[1]!.replace(",", "."));
	return Number.isFinite(v) && v > 0 ? v : null;
}

/** Saf model kodundaki (harfler + rakam) kVA'yı yakalar (ör. GJP50 → 50, GJB1000 → 1000). */
export function parseKvaFromModel(model: string | null | undefined): number | null {
	if (!model) return null;
	const m = model.trim().match(/^[A-ZÇĞİÖŞÜ]+(\d+)/i);
	if (!m) return null;
	const v = Number(m[1]);
	return Number.isFinite(v) && v > 0 ? v : null;
}

/**
 * GTIP (HS) kodunu ürün bilgisinden türetir. Jeneratör değilse veya dizel için
 * kVA belirlenemiyorsa null döner.
 */
export function deriveGtip(input: GtipInput): string | null {
	const code = (input.code ?? "").trim();
	const name = input.name ?? "";
	const model = input.model ?? "";
	const hay = `${name} ${model}`;

	// Sadece jeneratörler 8502 kapsamında
	const isGenerator = /jenerat/i.test(hay) || /\bGJ[A-ZÇĞİÖŞÜ]/i.test(hay);
	if (!isGenerator) return null;

	// Benzinli portatif: kod "7" ile başlar ve adında GJB geçer
	if (code.startsWith("7") && /GJB/i.test(hay)) return "8502.20";

	// Dizel: kVA bandı
	const kva = input.kva ?? kvaFromText(hay) ?? parseKvaFromModel(model);
	if (kva != null) {
		if (kva <= 75) return "8502.11";
		if (kva <= 375) return "8502.12";
		return "8502.13";
	}
	// kVA belirlenemedi: portatif (kod "7") ise küçük kabul edilir → 8502.11
	if (code.startsWith("7")) return "8502.11";
	return null;
}
